// Google Tag Manager Helper Utilities for Single Page Application (SPA)
export const GTM_ID = 'GTM-PHLDXDHH';

/**
 * Track a virtual pageview in Google Tag Manager
 * @param {string} path - The relative path of the page (e.g., /partner-with-us)
 * @param {string} title - The document title
 * @param {string} location - Full URL (window.location.href)
 */
export const trackPageView = (path, title, location) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'page_view',
      page_path: path || (window.location.pathname + window.location.search),
      page_title: title || document.title,
      page_location: location || window.location.href
    });
  }
};

/**
 * Track a custom event in Google Tag Manager
 * @param {string} action - The event name (e.g., 'quote_submitted', 'partner_inquiry')
 * @param {object} params - Event parameters
 */
export const trackEvent = (action, params = {}) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: action,
      ...params
    });
  }
};
